import styled from '@emotion/styled'

import { ReservationContainer } from '@containers/groupReservation/groupReservation.style'

export const BirthdayReservationContainer = styled(ReservationContainer)`
  max-width: 1440px;
  overflow: visible;
  color: white;
`

export const BirthdayReservationLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 20px;
  align-items: start;

  @media screen and (max-width: 1220px) {
    display: block;
  }
`

export const BirthdayReservationMain = styled.main`
  min-width: 0;
`

export const BirthdayReservationAside = styled.aside`
  position: sticky;
  top: 20px;

  @media screen and (max-width: 1220px) {
    position: static;
  }
`

export const BirthdayReservationTitle = styled.div<{
  $backgroundImage?: string
}>`
  position: relative;
  min-height: 140px;
  padding: 20px;
  margin-bottom: 20px;
  background: #353c4b;
  background-image: ${({ $backgroundImage }) =>
    $backgroundImage
      ? `linear-gradient(90deg, rgba(24, 28, 35, 0.94), rgba(24, 28, 35, 0.5)), url("${$backgroundImage}")`
      : 'none'};
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h1 {
    margin: 0 0 5px;
    font-size: 28px;
  }

  span {
    max-width: 720px;
    line-height: 1.5;
  }
`

export const BirthdayValidationPanel = styled.div`
  padding: 16px 20px;
  border: 2px solid #ff9b1a;
  border-radius: 8px;
  margin-bottom: 20px;
  color: #fff;
  background: #3b3025;

  strong {
    display: block;
  }

  ul {
    padding-left: 20px;
    margin: 8px 0 0;
  }

  li + li {
    margin-top: 5px;
  }
`

export const BirthdayReservationLoader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: white;
  font-size: 16px;
  text-align: center;
`
